import { Box, Flex, Image, Text, VStack } from "@chakra-ui/react";
import { Images } from "../../Assets/images";
import { useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";

type Props = {};

const SubscriptionPurchase = (props: Props) => {
  const navigate = useNavigate();

  return (
    <Box display={"flex"} flexDir={"column"} w={"100%"} minH={"100dvh"} bg={"white"}>
      {/* Claude: standard dark header with back arrow 11-04-2026 */}
      <Flex
        w={"100%"}
        px={"30px"}
        py={5}
        bg={"#0E122F"}
        color={"white"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Subscription</Text>
        </Flex>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            seller (beta)
          </Text>
        </VStack>
      </Flex>

      <Box px={6} pt={10} textAlign={"center"}>
        <Text fontSize={"16px"} fontWeight={"bold"} color={"black"}>
          Your subscription renewal request is received.
        </Text>
        <Text fontSize={"16px"} fontWeight={"bold"} mt={"80px"} color={"black"}>
          We will contact you on your registered email address and/or phone number shortly.
        </Text>
        <Text fontSize={"12px"} fontWeight={"medium"} mt={2} color={"black"}>
          For any queries, email{" "}
          <a style={{ color: "#F5793D" }} href="mailto:support@aftr.network">
            support@aftr.network
          </a>
        </Text>
      </Box>
    </Box>
  );
};

export default SubscriptionPurchase;
